import React from 'react';
import { NavLink } from 'react-router-dom';
import { X } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';
import clsx from 'clsx';

export interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n();

  if (!isOpen) return null;

  const navItems = [
    { to: '/apps', label: t.nav.apps },
    { to: '/support', label: t.nav.support },
    { to: '/about', label: t.nav.about },
    { to: '/contact', label: t.nav.contact },
  ];

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-slate-950/40 backdrop-blur-xs transition-opacity"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div className="fixed inset-y-0 right-0 w-full max-w-xs bg-white shadow-xl p-6 flex flex-col justify-between z-10 animate-slideIn">
        <div>
          {/* Header */}
          <div className="flex items-center justify-between pb-6 border-b border-slate-200">
            <span className="font-bold text-slate-900 tracking-tight flex items-center gap-2">
              <span className="w-6 h-6 rounded-md bg-primary-500 flex items-center justify-center text-white text-xs font-black">
                K
              </span>
              Kapitalletter Apps
            </span>
            <button
              type="button"
              onClick={onClose}
              className="p-2 -mr-2 text-slate-500 hover:text-slate-800 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
              aria-label="메뉴 닫기"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Links */}
          <nav className="mt-6 flex flex-col space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onClose}
                className={({ isActive }) =>
                  clsx(
                    'px-4 py-3 rounded-xl text-base font-medium transition-colors flex items-center justify-between min-h-[44px]',
                    isActive
                      ? 'bg-primary-50 text-primary-800 font-semibold'
                      : 'text-slate-700 hover:bg-slate-50 hover:text-slate-900'
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};
